import { all, call } from 'redux-saga/effects';

import { authSagas } from './auth/auth.sagas';
import { ebaySagas } from './ebay/ebay.sagas';

export default function* rootSaga() {
  yield all([call(authSagas), call(ebaySagas)]);
}
